import React from 'react';

// Generated from the LegalApp design canvas.
export default function BookBSA({ style }) {
  style = { ...{  }, ...style };
  return (
    <svg className="lp-book-iso" viewBox="-61.4 -24.0 147.1 108.0" role="img" aria-label="BSA book" style={style}>
    <polygon points="79.7,46.0 24.2,78.0 24.2,75.0 79.7,43.0" fill="#B4CCF7" />
    <polygon points="-55.4,32.0 24.2,78.0 24.2,75.0 -55.4,29.0" fill="#DCE7FC" />
    <polygon points="0.0,-3.0 79.7,43.0 24.2,75.0 -55.4,29.0" fill="#FFFFFF" />
    <polygon points="77.9,42.0 25.1,72.5 25.1,60.5 77.9,30.0" fill="#E3EBFB" />
    <polygon points="-51.1,28.5 25.1,72.5 25.1,60.5 -51.1,16.5" fill="#F4F7FE" />
    <polygon points="1.7,-14.0 77.9,30.0 25.1,60.5 -51.1,16.5" fill="#FFFFFF" />
    <polygon points="74.5,42.0 27.7,69.0 27.7,68.1 74.5,41.1" fill="#BCD1F8" />
    <polygon points="74.5,38.6 27.7,65.6 27.7,64.7 74.5,37.7" fill="#BCD1F8" />
    <polygon points="74.5,35.2 27.7,62.2 27.7,61.3 74.5,34.3" fill="#BCD1F8" />
    <polygon points="79.7,31.0 24.2,63.0 24.2,60.0 79.7,28.0" fill="#B4CCF7" />
    <polygon points="-55.4,17.0 24.2,63.0 24.2,60.0 -55.4,14.0" fill="#DCE7FC" />
    <polygon points="0.0,-18.0 79.7,28.0 24.2,60.0 -55.4,14.0" fill="#FFFFFF" />
    <polygon points="-55.4,32.0 24.2,78.0 24.2,60.0 -55.4,14.0" fill="#B4CCF7" />
    <polygon points="-46.8,33.0 -24.2,46.0 -24.2,36.0 -46.8,23.0" fill="#FFFFFF" opacity="0.55" />
    <polygon points="43.3,75.0 39.0,77.5 39.0,64.5 43.3,62.0" fill="#F2A33A" />
    <text transform="matrix(0.8660 -0.5 0.8660 0.5 -1.7 37.0)" className="lp-iso-book" fill="#0B1B3F">
      {"BSA"}
    </text>
    </svg>
  );
}
